export default {"src":"/login-app/[GIT_HASH]/_next/static/media/check_error.73baad45.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};